"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: pre-wrap;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  padding: 3.75em 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  color: var(--color-grey-light-4);\n  font-weight: bold;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  padding: 0.75em 0.35em;\n  border-bottom: 1px solid var(--color-grey-light-4);\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding-bottom: 0.75rem;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 0 0 10px 10px;\n  padding: 0.75rem 1.5em;\n  background-color: ", ";\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 10px 10px 0 0;\n  font-weight: bold;\n  padding: 1.5em;\n  background-color: ", ";\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  max-width: ", ";\n  min-width: ", ";\n  border: 1px solid var(--color-grey-light-3);\n  box-shadow: var(--box-shadow-node);\n\n  border-radius: 0.75em;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var scenario_state_1 = require("../../redux/scenario/scenario.state");

var scenario_node_view_styles_1 = require("../scenario-node-view/scenario-node-view.styles"); // size は em を使用 (props.scale の値によって拡大, 縮小させるため)


var defaultDesign = scenario_state_1.INITIAL_SCENARIO_DESIGN.textScenarioNode;
exports.StyledTextNodeDiv = styled_components_1.default.div(_templateObject(), function (props) {
  return props.theme.fontSize.default + 'rem';
}, function (props) {
  return props.theme.maxWidth + 'rem';
}, function (props) {
  return props.theme.minWidth + 'rem';
});
exports.StyledTextNodeDiv.defaultProps = {
  theme: scenario_node_view_styles_1.DEFAULT_SCENARIO_NODE_THEME
}; // overflow hidden は editable-text-scenario-editor 側の都合でしようできないため header, body で border-radisu を設定

exports.StyledTextNodeHeaderDiv = styled_components_1.default.div(_templateObject2(), function (props) {
  return props.headerBackColor ? props.headerBackColor : defaultDesign.headerBackColor;
}, function (props) {
  return props.headerTextColor ? props.headerTextColor : defaultDesign.headerTextColor;
});
exports.StyledTextNodeBodyDiv = styled_components_1.default.div(_templateObject3(), function (props) {
  return props.bodyBackColor ? props.bodyBackColor : defaultDesign.bodyBackColor;
}, function (props) {
  return props.bodyTextColor ? props.bodyTextColor : defaultDesign.bodyTextColor;
});
exports.StyledTextOptionsUl = styled_components_1.default.ul(_templateObject4());
exports.StyledTextOptionLi = styled_components_1.default.li(_templateObject5());
exports.StyledEmptyOptionP = styled_components_1.default.p(_templateObject6());
exports.StyledWordBreakP = styled_components_1.default.p(_templateObject7());